<template>
  <MainLayout :initialDrawerExpanded="false" contentClass="pa-0" :has-sidebar="false">
    <template #header>
      <PageBack />
    </template>

    <template #content>
      <div class="d-flex" style="height: calc(100vh - 64px); overflow: hidden;">

        <!-- Sidebar -->
        <div style="width: 320px; min-width: 320px; border-right: 1px solid rgba(0,0,0,0.12); overflow-y: auto;">
          <div class="pa-3 d-flex align-center">
            <span class="subtitle-2 grey--text text--darken-2">
              {{ conversations.length }} conversations
            </span>
            <v-spacer />
            <v-progress-circular v-if="loading" indeterminate size="18" width="2" color="primary" />
          </div>

          <v-text-field
            v-model="search"
            placeholder="Rechercher…"
            dense outlined hide-details
            class="mx-3 mb-2"
            prepend-inner-icon="mdi-magnify"
            clearable
          />

          <v-list dense nav>
            <v-list-item
              v-for="conv in filtered"
              :key="conv.id"
              :class="{ 'v-list-item--active primary--text': selected && selected.id === conv.id }"
              @click="selectConv(conv)"
              style="border-radius: 6px;"
            >
              <v-list-item-content>
                <v-list-item-title class="caption font-weight-medium" style="white-space:normal;line-height:1.3;">
                  {{ conv.title || '(sans titre)' }}
                </v-list-item-title>
                <v-list-item-subtitle class="caption">
                  {{ conv.username }} · {{ conv.messages.length }} msg
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>

        <!-- Conversation pane -->
        <div v-if="selected" style="flex:1; overflow-y:auto;" class="pa-6">
          <div class="mb-4">
            <div class="subtitle-1 font-weight-medium">{{ selected.title || '(sans titre)' }}</div>
            <div class="caption grey--text">{{ selected.username }} · {{ formatDate(selected.created_at) }}</div>
          </div>

          <div v-for="msg in selected.messages" :key="msg.created_at" class="mb-4">
            <div class="d-flex align-start">
              <v-chip
                x-small
                :color="msg.role === 'user' ? 'primary' : 'grey lighten-2'"
                :dark="msg.role === 'user'"
                class="mr-3 mt-1"
                style="min-width: 70px; justify-content: center;"
              >
                {{ msg.role }}
              </v-chip>
              <div v-if="msg.role === 'assistant'" class="message body-2" style="flex:1;" v-html="render(msg.content)" />
              <div v-else class="body-2" style="flex:1; line-height:1.6;">{{ msg.content }}</div>
            </div>
            <v-divider class="mt-3" />
          </div>
        </div>

        <div v-else class="d-flex align-center justify-center grey--text" style="flex:1;">
          Sélectionnez une conversation
        </div>

      </div>
    </template>
  </MainLayout>
</template>

<script>
import PageBack from '@/components/ui/PageBack.vue'
import MainLayout from '@/layout/MainLayout.vue'
import MarkdownIt from 'markdown-it'

const md = new MarkdownIt({ html: false, linkify: true })

export default {
  name: 'AdminConversationsBrowser',
  components: { PageBack, MainLayout },

  data() {
    return {
      loading: false,
      conversations: [],
      selected: null,
      search: '',
    }
  },

  computed: {
    filtered() {
      if (!this.search) return this.conversations
      const q = this.search.toLowerCase()
      return this.conversations.filter(c =>
        (c.title || '').toLowerCase().includes(q) ||
        c.username.toLowerCase().includes(q) ||
        c.messages.some(m => m.content.toLowerCase().includes(q))
      )
    },
  },

  async mounted() {
    this.loading = true
    try {
      const res = await fetch('/tmp_opti_conversations.json')
      const data = await res.json()
      this.conversations = data.conversations
      if (this.$route.params.id) {
        this.selected = this.conversations.find(c => String(c.id) === String(this.$route.params.id)) || null
      }
    } finally {
      this.loading = false
    }
  },

  methods: {
    selectConv(conv) {
      this.selected = conv
      this.$router.replace({ name: 'admin_conversations_browser', params: { id: conv.id } })
    },

    render(content) {
      return md.render(content || '')
    },

    formatDate(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })
    },
  },
}
</script>

<style lang="scss">
.message {
  table {
    width: 100%;
    display: block;
    overflow-x: scroll;
  }
  table, th, td {
    border: 1px solid #ccc;
    border-collapse: collapse;
  }
  td { padding: 4px; }
  h1, h2, h3, h4, h5, h6, strong, li::marker, th {
    margin-top: 16px;
    margin-bottom: 8px;
    font-weight: bold;
    color: var(--v-secondary-base);
  }
  hr {
    border: none;
    border-top: 1px solid #ccc;
    margin: 16px 0;
  }
}
</style>
